{
    "Profile_Residents_CancellationReason.cancellation": "Cancellation",
    "Profile_Residents_CancellationReason.cancellationDetails": "Cancellation Details",
    "Profile_Residents_CancellationReason.dateOfCancellation": "Date of Cancellation",
    "Profile_Residents_CancellationReason.cancellationReason": "Cancellation Reason"
}
